export const commonConstants = {
    SECRET_KEY_REQUEST: 'SECRET_KEY_REQUEST',
    SECRET_KEY_SUCCESS: 'SECRET_KEY_REQUEST_SUCCESS',
    SECRET_KEY_FAILURE: 'SECRET_KEY_REQUEST_FAILURE',
    
    CLEAR_ERROR: 'CLEAR_SECRET_KEY_ERROR_CODE',
    NUMBER_DAY_IN_YEAR: 365,
    TIME_START: "08:00",
    TIME_END: "17:00",
    MINUTE_STEP: 15,
    ERROR_CODE: "042",
    ERROR_CODE_FOR_YEAR: "043",
    SPECIAL_LEAVE_TYPE: 10,
    LEAVE_TYPE_DATA_DETAIL: {
        0: "submitted",
        1: "approved",
        2: "rejected",
    },
    APPROVE: 0,
    UNAPPROVE: 1,
    SUBMITTED: 0,
    APPROVED: 1,
    REJECT: 2,
    HAS_PERMISSION: {
        MY_DETAIL_REQUEST: 0,
        ALL_DETAIL_REQUEST: 1,
    },
    DISABLED_PROJECT: ["MW1", "MW2", "MW3", "MW4"],
    NUMBER_DAY_IN_MONTH: 30,
    WORK_TIME: 8,
    VALUE_RADIO_DAY: "day",
    VALUE_RADIO_HOUR: "hour",
    MIN_REQUEST_TIME: 0.1,
};
